import get from 'lodash/get';
import includes from 'lodash/includes';

import {
  STORE_LINKS,
  OPERATING_SYSTEMS,
} from './constants/device';

export const getOperatingSystem = (ctx) => {
  let userAgent = '';

  if (process.browser) {
    userAgent = get(navigator, 'userAgent');
  } else {
    userAgent = get(ctx, 'req.headers.user-agent');
  }

  const isAndroid = includes(userAgent, 'Android');
  if (isAndroid) {
    return OPERATING_SYSTEMS.ANDROID;
  }

  // On iPad iOS 13, the user agent is identical with that of a MacOS 13 computer so this will not catch it.
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !includes(userAgent, 'Windows Phone');
  if (isIOS) {
    return OPERATING_SYSTEMS.IOS;
  }

  return OPERATING_SYSTEMS.OTHER;
};

export const getIsAndroid = ctx => getOperatingSystem(ctx) === OPERATING_SYSTEMS.ANDROID;

export const getIsIOS = ctx => getOperatingSystem(ctx) === OPERATING_SYSTEMS.IOS;

export const openAppStoreIfNeeded = (router) => {
  const shouldDownloadNativeApp = get(router, 'query.app_dl') === '1';
  const operatingSystem = getOperatingSystem();
  const isIosOrAndroid = [OPERATING_SYSTEMS.IOS, OPERATING_SYSTEMS.ANDROID].includes(operatingSystem);

  if (shouldDownloadNativeApp && isIosOrAndroid && typeof window !== 'undefined') {
    window.location.replace(STORE_LINKS[operatingSystem]);
  }
};

export default {
  getIsAndroid,
  getIsIOS,
  getOperatingSystem,
  openAppStoreIfNeeded,
};
